/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   getFeaturedAndSpotlightLimits
 */

import type { ExtraThunkArg } from '@zcode/state-type'
import {
  DEFAULT_FEATURED_API_LIMIT,
  DEFAULT_FEATURED_API_LIMIT_NEW,
  DEFAULT_FEATURED_LIMIT,
  DEFAULT_SPOTLIGHT_LIMIT,
  DEFAULT_SPOTLIGHT_LIMIT_NEW,
} from '../constants/featuredAndSpotlight'

const SPOTLIGHT_INCREASE = 'spotlight_increase'

export const getFeaturedAndSpotlightLimits = (optimizely: ExtraThunkArg['optimizely']) => {
  const isSpotlightLimitIncrease = optimizely.getVariation(SPOTLIGHT_INCREASE) !== 'show_old_limit'

  const limits = {
    DEFAULT_FEATURED_API_LIMIT: isSpotlightLimitIncrease
      ? DEFAULT_FEATURED_API_LIMIT_NEW
      : DEFAULT_FEATURED_API_LIMIT,
    DEFAULT_FEATURED_LIMIT,
    DEFAULT_SPOTLIGHT_LIMIT: isSpotlightLimitIncrease
      ? DEFAULT_SPOTLIGHT_LIMIT_NEW
      : DEFAULT_SPOTLIGHT_LIMIT,
  } as const

  return limits
}
